export const knowledgeBaseRoutes = [
  {
    path: '/knowledge/index',
    name: 'knowledgeIndex',
    meta: { title: '知识库', isShowOrHiddenNavBar: 0, keepAlive: true },
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/KnowledgeBase/index'),
  },
  {
    path: '/knowledge/detail',
    name: 'knowledgeDetail',
    meta: { title: '问题解答', isShowOrHiddenNavBar: 0 },
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/KnowledgeBase/detail'),
  },
  {
    path: '/knowledge/search',
    name: 'knowledgeSearch',
    meta: { title: '搜索', isShowOrHiddenNavBar: 0 },
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/KnowledgeBase/search'),
  },
];
